module.exports = __webpack_public_path__ + "static/favicon-256x256.04e7dc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/favicon-256x256.png
// module id = 641
// module chunks = 114276838955818